import { getReports as getCurriculumReports } from './CurriculumReportService';
import { fetchSessionJson } from '../SessionRequest';
import { toRequiredPositiveInteger } from '../Utilities';
import type { ReportDefinition } from '../../types/ReportDefinition';

const API_SERVER = process.env.API_SERVER || '';

export async function getReports(
  classId: number | string | null | undefined
): Promise<ReportDefinition[]> {
  // Match Angular's classReports behavior when no class has been selected.
  if (!classId) {
    return [];
  }

  const validatedClassId = toRequiredPositiveInteger(classId, 'classId');

  return fetchSessionJson<ReportDefinition[]>(
    `${API_SERVER}/subscriptions/admin/classes/${validatedClassId}/reports`,
    'Failed to fetch class reports'
  );
}

export async function getReportsForClassMode(
  classId: number | string | null | undefined
): Promise<ReportDefinition[]> {
  if (!classId) {
    return [];
  }

  const validatedClassId = toRequiredPositiveInteger(classId, 'classId');
  const course = await fetchSessionJson<{ licenses?: unknown[] } | null>(
    `${API_SERVER}/classes/${validatedClassId}`,
    'Failed to fetch class details'
  );
  // ClassMode only offers reports for licensed classes, with class reports listed first.
  if (!course?.licenses?.length) {
    return [];
  }

  const classReports = await getReports(validatedClassId);
  const curriculumReports = await getCurriculumReports(validatedClassId);
  return classReports.concat(curriculumReports);
}

const ClassReportService = { getReports, getReportsForClassMode };

export default ClassReportService;
